import { Component, input, signal } from '@angular/core';
import { TooltipsModule } from '../../features/tooltip/tooltips.module';
import { EIconPath } from '../../shared/enums/icons.enum';
import { IconModule } from '../icon/icon-module';

@Component({
  selector: 'pp-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  imports: [IconModule, TooltipsModule],
})
export class AccordionComponent {
  readonly ppTitle = input.required<string>();

  readonly expanded = signal<boolean>(true);
  readonly EIconPath = EIconPath;

  toggle(): void {
    this.expanded.update((expanded) => !expanded);
  }
}
